module.exports = __webpack_public_path__ + "img/topup_off.3167e1de.svg";